export default "__VITE_ASSET__DfvsFTTr__"